import React, { FC } from "react";
import MDEditor from "@uiw/react-md-editor";

import { ChatMessageContainer, ChatMessageWrapper } from "./styled";
import { ChatChart } from "./ChatChart";

import { ChatMessage } from "./types";

export const Message: FC<ChatMessage> = ({ text, chartData, isSelf }) => {
  return (
    <ChatMessageWrapper isSelf={isSelf}>
      <ChatMessageContainer data-color-mode="light">
        <MDEditor.Markdown source={text} />
        <ChatChart chartData={chartData} />
      </ChatMessageContainer>
    </ChatMessageWrapper>
  );
};
